import { render, staticRenderFns } from "./LinkSharer.vue?vue&type=template&id=d1d505c8&scoped=true&"
import script from "./LinkSharer.vue?vue&type=script&lang=js&"
export * from "./LinkSharer.vue?vue&type=script&lang=js&"
import style0 from "./LinkSharer.vue?vue&type=style&index=0&id=d1d505c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d505c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1d505c8')) {
      api.createRecord('d1d505c8', component.options)
    } else {
      api.reload('d1d505c8', component.options)
    }
    module.hot.accept("./LinkSharer.vue?vue&type=template&id=d1d505c8&scoped=true&", function () {
      api.rerender('d1d505c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/LinkSharer.vue"
export default component.exports